// extracted by mini-css-extract-plugin
export var indeterminate = "_64-5";
export var md = "_64-4";
export var semantic = "_64-6";
export var sm = "_64-3";
export var text = "_64-7";
export var toggleInput = "_64-0";
export var toggleSwitch = "_64-1";
export var xs = "_64-2";